export default "/fonts/vendor/katex/dist/KaTeX_SansSerif-Regular.ttf?2f7bc363fc5424ebda5903f74c404a99";